import { render, staticRenderFns } from "./ContratForm.vue?vue&type=template&id=667a5176&"
import script from "./ContratForm.vue?vue&type=script&lang=js&"
export * from "./ContratForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports